import { Flex, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type SelectedCountPillProps = {
  selectedCount: number;
};

export function SelectedCountPill({ selectedCount }: SelectedCountPillProps) {
  return (
    <Flex
      align="center"
      px="md"
      py="xxs"
      gap="xxs"
      bg="orange.1"
      style={{
        borderRadius: 12,
      }}
    >
      <Text size="sm" fw={FONT_WEIGHTS.medium} c="gray.10">
        {selectedCount} selected
      </Text>
    </Flex>
  );
}
